export const Z_INDICES = {
  BASE_CONTENT: 10,
  HEADER: 1000,
  POPOVER: 9000,
}
